<template>
  <div class="section-wrapper">
    <div class="row">
      <volcan-input-text
        v-model="getItemRes.name"
        text="Modèle"
        class="col-6"
      />
      <volcan-input-text
        v-model="machineryLocal.year"
        text="Année"
        class="col-6"
      />
    </div>
    <div class="row">
      <volcan-input-redactor
        v-model="getItemRes.details"
        text="Accessoires"
        class="col-12"
      />
    </div>
    <div class="row">
      <div class="col-6 mt-4">
        <volcan-input-select2
          valueFormat="id"
          :allowClear="false"
          :multiple="false"
          text="Sélectionner une catégorie"
          placeholder="--"
          apiUrl="/api/category/datatable/?sort=&page=1&per_page=100"
          v-model="machineryLocal.categoryId"
          class="col-12"
        ></volcan-input-select2>
        <volcan-input-select2
          valueFormat="id"
          :allowClear="false"
          :multiple="false"
          text="Sélectionner la marque"
          placeholder="--"
          apiUrl="/api/make/datatable/?sort=&page=1&per_page=100"
          v-model="machineryLocal.makeId"
          class="col-12"
        ></volcan-input-select2>
      </div>
      <div class="col-6">
        <volcan-dropzone
          v-model="machineryLocal.image"
          :moduleName="moduleName"
          :options="{
            thumbnailHeight: 150,
            thumbnailWidth: 150,
            dictDefaultMessage: 'Déposer un fichier (cliquer glisser)',
            acceptedFiles: 'image/*',
            maxFiles: 1,
          }"
          text="Photo"
          class="col-12"
        />
      </div>
    </div>
  </div>
</template>
<script>
import helpers from "@mixins/helpers.js";
export default {
  name: "volcan-machinery",
  mixins: [helpers],
  data() {
    return {
      tabs: {
        languageIdActive: 0,
        content: {
          content: {
            title: "Contenu",
            active: true,
            hasLanguage: true,
          },
          seo: {
            title: "Seo",
            active: false,
            hasLanguage: true,
          },
        },
      },
    };
  },
  props: {
    machinery: { type: Object },
    languageIdActive: { type: Number },
    moduleName: { type: String },
  },
  model: {
    prop: "machinery",
    event: "machinery:change",
  },
  watch: {
    languageIdActive: function (val) {
      this.tabs.languageIdActive = val;
    },
  },
  computed: {
    machineryLocal: {
      get() {
        return this.machinery;
      },
      set(value) {
        this.$emit("machinery:change", value);
      },
    },
    getItemRes() {
      return this.getResWithLangId(this.machineryLocal, this.languageIdActive);
    },
  },
  methods: {},
};
</script>
<style></style>



// WEBPACK FOOTER //
// components/Custom/machinery/machinery.vue